import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import type { Language } from '../types';
import { activatePwaUpdate, finishDeferredPwaReload, isSafePwaUpdatePath, usePwaStatus } from '../pwa/updateService';

const copy = {
  en: {
    update: 'A new version is ready.',
    action: 'Update now',
    updating: 'Updating…',
    error: 'Unable to update. Check your connection and try again.',
    retry: 'Try again',
  },
  ms: {
    update: 'Versi baharu sudah tersedia.',
    action: 'Kemas kini',
    updating: 'Sedang mengemas kini…',
    error: 'Tidak dapat mengemas kini. Semak sambungan anda dan cuba lagi.',
    retry: 'Cuba lagi',
  },
} as const;

export function PwaUpdatePrompt({ language }: { language: Language }) {
  const location = useLocation();
  const { updateAvailable, phase } = usePwaStatus();
  const text = copy[language];
  const safe = isSafePwaUpdatePath(location.pathname);
  useEffect(() => {
    if (safe && phase === 'ready') finishDeferredPwaReload();
  }, [safe, phase]);
  if (!updateAvailable || !safe) return null;
  const updating = phase === 'updating' || phase === 'ready';
  return <aside className="pwa-notice" aria-live="polite">
    <div><strong>{text.update}</strong>{phase === 'error' && <small role="alert">{text.error}</small>}</div>
    <button type="button" disabled={updating} aria-busy={updating} onClick={() => { void activatePwaUpdate(); }}>
      {updating ? text.updating : phase === 'error' ? text.retry : text.action}
    </button>
  </aside>;
}
